import CommercialStagingForm from "./CommercialStagingForm"

const DaytoDuskForm = () => {
    return (
        <CommercialStagingForm form_name="Day to Dusk" />
    )
}

export default DaytoDuskForm;